import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import VideoDrawer from '@blade/common/components/paint/draw-with-video.vue';
import { getModel, getCrossLineTasks } from '@blade-sxp/monitor/api/monitor-management/task';
let default_1 = class default_1 extends Vue {
    taskType;
    showMode;
    deviceId;
    rtspAddress;
    dataSource;
    buttons;
    limits;
    isPlayFlag;
    directionConfig;
    mode = 'LOCALIZATION';
    relevantTask = [];
    drawend(atlas) {
        this.$emit('drawend', atlas, this.mode);
    }
    handleChange(val) {
        let message = this.$t('changeMode').toString();
        if (this.relevantTask.length > 0) {
            const msg = this.relevantTask.map((item, index) => `${index + 1}、    ${item}`).join('\n');
            message = `${this.$t('changeModeTitle').toString()}\n${msg}`;
        }
        this.$elconfirm(message, `${this.$t('common.warning')}`, {
            confirmButtonText: this.$t('comfirm').toString(),
            cancelButtonText: this.$t('cancel').toString(),
            type: 'warning',
            center: true,
        })
            .then(() => {
        })
            .catch(() => {
            this.mode = val === 'HARPY' ? 'LOCALIZATION' : 'HARPY';
        });
    }
    mounted() {
        if (this.taskType === 2 && this.deviceId) {
            getModel(this.deviceId).then((resp) => {
                this.mode = resp.data.data?.crossLineMode || 'LOCALIZATION';
            }).catch(error => {
                this.$message.error(error.message);
            });
            getCrossLineTasks(this.deviceId).then((resp) => {
                this.relevantTask = resp.data.data || [];
            }).catch(error => {
                this.$message.error(error.message);
            });
        }
    }
};
__decorate([
    Prop({ default: -1 })
], default_1.prototype, "taskType", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "showMode", void 0);
__decorate([
    Prop({ default: '' })
], default_1.prototype, "deviceId", void 0);
__decorate([
    Prop({ default: '' })
], default_1.prototype, "rtspAddress", void 0);
__decorate([
    Prop({ default: [] })
], default_1.prototype, "dataSource", void 0);
__decorate([
    Prop({ default: [] })
], default_1.prototype, "buttons", void 0);
__decorate([
    Prop()
], default_1.prototype, "limits", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "isPlayFlag", void 0);
__decorate([
    Prop()
], default_1.prototype, "directionConfig", void 0);
default_1 = __decorate([
    Component({
        name: 'roi-drawer',
        components: { VideoDrawer },
        i18n: {
            messages: {
                'en-us': {
                    headMode: 'Head Cross-line Statistics(Default)',
                    bodyMode: 'Foot Cross-line Statistics',
                    changeMode: 'it may affect the identification accuracy of the current task,determine to modify the model?',
                    changeModeTitle: 'The following task items of the device will be affected by the operation of changing the model. Please be careful：',
                    comfirm: 'Still Modify',
                    cancel: 'Cancel',
                },
                zh: {
                    headMode: '头部跨线统计（默认）',
                    bodyMode: '脚部跨线统计',
                    changeMode: '修改模型后，可能会影响当前任务的识别精度，确定修改模型？',
                    changeModeTitle: '更改模型操作会一并影响该设备的以下任务项，请谨慎操作：',
                    comfirm: '仍然修改',
                    cancel: '取消',
                },
            },
        },
    })
], default_1);
export default default_1;
